<template>
  <div class="zchjs">
    <div class="header">
      <div class="zhuti">
        <div class="h1">连接供需，共创价值
        </div>
        <div class="h2">
          <p>企业轻松发布代加工需求或展示生产能力，精准匹配</p>
          <p> 合作伙伴，拓展业务机会，实现资源共享与合作共赢</p>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="border">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="mbx">
          <el-breadcrumb-item  :to="{ path: '/daigonglist' }">需求列表</el-breadcrumb-item>
          <el-breadcrumb-item >需求详情</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="top">
          <div class="title">
            <div class="gx gong" v-if="datas.sdType==0">供</div>
            <div class="gx  xu" v-else>需</div>
            {{datas.title}}
          </div>
          <div class="time">{{datas.createTime}}</div>
        </div>
        <div class="comp">
          <div class="flex">
            <div class="img">
              <el-image :src="datas.image"></el-image>
            </div>
            <div class="flex-1">
              <div  class="h0">{{datas.tenantName}}</div>
              <div class="h1">联系人：{{datas.phone}}</div>
              <div >联系方式：{{datas.contacts}}</div>
            </div>
            <div class="right">
              <el-button type="text" style="color: #61B932" v-if="datas.isMe">由我发布</el-button>
              <el-button v-else-if="datas.isEnlists" disabled type="primary" round size="small">已报名</el-button>
              <el-button v-else  type="primary" style="padding: 10px 36px" @click.stop="zixun(datas)"  round size="small">报名</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="flex neirong">
        <div class="flex-1">
          <div class="border desc">
            <div class="title">需求描述</div>
            <div style="padding: 20px 0" v-html="datas.intro"></div>
          </div>
          <div class="border desc">
            <div class="title">详情</div>
            <div style="padding: 20px 0" v-html="datas.content"></div>
          </div>
          <div class="border desc">
            <div class="title">需求附件</div>
            <div style="padding: 20px 0">
              <fujian  :files="datas.file"></fujian>
            </div>
          </div>
          <div class="border desc baomingpeople" v-if="ul1.length>0" v-for="(li,index) in ul1" :key="index">
            <div class="title">报名信息 <span class="right">报名于 {{li.createTime}}</span></div>
            <div  class="mybaoming">
              <div>企业名称：  <span>{{li.tenantName}}</span></div>
              <div>联系人：  <span>{{li.contacts}}</span> 联系方式：  <span>{{li.phone}}</span></div>
              <div>描述： {{li.content}}</div>
              <div  v-if="li.file&&li.file.length>0">附件：   <fujian  :files="li.file"></fujian></div>
            </div>
          </div>
          <div class="border desc" style="margin-top: 20px;font-size: 12px;color: #4C4C4C;line-height: 25px">
            <h3>免责声明：</h3>
            <p>本网站作为信息服务平台，所有信息均由企业自行上传、发布。</p>
            <p> 用户发布信息的真实性、准确性等不作保证。</p>
            <p> 因上述原因导致的对其他用户或第三方造成的损失，本网站不承担责任。</p>
          </div>
        </div>
        <div class="baoming">
          <div class="border line">已在线报名<span class="blue">{{data.total}}</span>人</div>
          <div class="border" style="margin-top: 15px">
            <div v-for="(li,index) in ul" :key="index" class="flex ming">
              <div class="img">
              </div>
              <div class="flex-1">
                <div class="title">{{li.tenantName}}</div>
                <div v-if="datas.isMe">{{li.contacts}}   {{li.phone}}</div>
                <div v-else>{{maskName(li.contacts)}}   {{maskPhoneNumber(li.phone)}}</div>
                <div v-if="!datas.isMe">(报名详情仅需求发布方可见)</div>
                <div>{{li.createTime}}</div>
              </div>
            </div>
            <div style="padding: 10px 0;text-align:center" v-if="ul.length>0&&datas.isMe">
              <el-button type="primary" size="small" @click="more">查看更多</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="报名" width="600px" append-to-body :visible.sync="dialogTableVisible">
      <el-form ref="form" :model="shen" label-width="120px" :rules="rules">
        <el-form-item label="报名描述：" prop="content">
          <el-input rows="5"  style="width: 300px" type="textarea" v-model="shen.content"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contacts">
          <el-input   v-model="shen.contacts"></el-input>
        </el-form-item>
        <el-form-item label="手机号"   prop="phone">
          <el-input  v-model.number="shen.phone"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style="margin-top: 20px;margin-left: 8px" @click="submitForm()">提交报名</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>

</template>

<script>
import {contractenlistslist, contractprocessingdetail} from "@/request/moudle/demand";
import fujian from "@/views/common/fujian.vue";
import {maskName,maskPhoneNumber} from "@/utils/index.js";
export default {
  name: "zchj",
  components: {fujian},
  data(){
    return {
      maskName:maskName,
      maskPhoneNumber:maskPhoneNumber,
      datas:{

      },
      data:{},
      tableData:[],
      ul:[],
      ul1:[],
      shen:{},
      zxid:'',
      dialogTableVisible:false,
      rules: {
        content: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        contacts: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入', trigger: 'blur' },{ type: 'number', message: '手机号必须为数字值'}
        ]
      },
    }
  },
  created() {
    this.loadxq()
  },
  methods:{
    zixun(item){
      this.shen={}
      this.zxid=item.id
      this.dialogTableVisible=true
    },
    submitForm(){
      this.shen.cpId=this.zxid
      this.$api.demand.processingenlists(this.shen).then((res)=>{
        this.dialogTableVisible=false
        this.$message({
          type: "success",
          message: "提交成功!"
        });
        this.loadxq()
      })
    },
    more(){
      this.$router.push({
        path:'/baominglist',
        query:{
          id:this.datas.id
        }
      })
    },
    loadxq(){
      this.$api.demand.contractprocessingdetail({
        id:this.$route.query.id
      }).then((res)=>{
        this.datas=res.data;
      })
      this.$api.demand.contractenlistslist({
        current:1,
        cpId:this.$route.query.id,
        size:5
      }).then((res)=>{
        this.data=res.data
        this.ul=res.data.records;
      })
      this.$api.demand.contractenlistslist({
        current:1,
        isMe:true,
        cpId:this.$route.query.id,
        size:1
      }).then((res)=>{
        this.ul1=res.data.records;
      })
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-input{
  width: 300px;
}
/deep/ .el-image{
  border-radius: 4px;
}
.header{
  height: 230px;
  background: url("../../assets/gxjy/daigong.png") no-repeat;
  background-size: 100% 100%;
  padding-top: 90px;
  color: #fff;
  .h1{
    font-size: 42px;
    margin-top: 25px;
  }
  .h2{
    font-size: 20px;
    line-height: 30px;
    margin-top: 15px;
  }
}
.mbx{
  padding: 24px 0 24px 24px;
  border-bottom: 1px solid #eeeeee;
}
.border{
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}
.zhuti{
  width: 1200px;
  margin: 0 auto;
}
.content{
  width: 1200px;
  margin: 20px auto;
  .desc{
    padding: 24px;
    margin-bottom: 20px;
    .title{
      font-weight: bolder;
      font-size: 16px;
    }
  }
  .top{
    padding: 24px;
    border-bottom: 1px solid #eeeeee;
    .time{
      font-size: 12px;
      color: #999999;
    }
    .title{
      font-size: 18px;
      font-weight: bolder;
      line-height: 35px;
    }
  }
  .comp{
    padding: 24px;
    font-size: 12px;
    .right{
      margin: 30px 0px 0 0;
    }
    .h0{
      font-weight: bolder;
      font-size: 14px;
      margin-top: 5px;
    }
    .h1{
      line-height: 45px;
    }
    .img{
      width: 100px;
      height: 100px;
      margin-right: 15px;
      border-radius: 6px;
    }
  }
  .neirong{
    margin-top: 20px;
  }
  .baoming{
    width: 310px;
    margin-left: 18px;
    .ming{
      margin-bottom: 15px;
      padding: 12px;
      font-size: 12px;
      color: #999999;
      line-height: 25px;
      .title{
        font-size: 14px;
        color: #333333;
      }
      .img{
        width: 40px;
        height: 40px;
        margin-right: 10px;
        background: url("../../assets/gxjy/ming.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .line{
      border-left:4px solid #0c8aff;
      padding: 10px 10px;
    }
    .blue{
     color: #0c8aff;
      margin: 0 5px;
    }
  }
  .baomingpeople{
    .right{
      float: right;color: #999999;font-size: 12px;font-weight: normal;
    }
    .mybaoming{
      color: #999999;
      div{
        padding: 8px 0;
      }
      span{
        color: #333333;
        margin-right: 20px;
      }
    }
  }
}
.gx{
  border-radius: 4px;
  color: #fff;
  text-align: center;
  width: 30px;
  height: 30px;
  line-height: 30px;
  font-weight: bolder;
  font-size: 14px;
  display: inline-block;
  margin-right: 10px;
}
.gong{
  background: #1266F9;
}
.xu{
  background: #61B932;
}
</style>